import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { axiosInstance } from "../../../utils/client";

interface UserState {
  isLoading: boolean;
  error: string | false;
  addresses: {
    id: number;
    addressTittle: string;
    contactName: string;
    contactNo: string;
    addressLine1: string;
    addressLine2?: string;
    state: string;
    country: string;
    zipCode: string;
    cityId: 0;
    city: string;
  }[];
  user: any;
}

const initialState: UserState = {
  isLoading: false,
  error: false,
  addresses: [],
  user: null,
};

const slice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    hasError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setAddresses: (state, action) => {
      state.addresses = action.payload;
    },
  },
});

export default slice.reducer;

export const { setLoading, hasError, setUser, setAddresses } = slice.actions;

export function fetchUser(id: number) {
  return async (dispatch: any, getState: () => any) => {
    // const { dispatch } = store;
    try {
      const response = await axiosInstance.get(`/user/${id}`);
      // console.log(response);
      if (response?.data) {
        dispatch(setUser(response.data));
        dispatch(setAddresses(response.data.userAddressResponses));
      }
    } catch (error) {
      console.log(error);
      dispatch(hasError(error));
    }
  };
}

// export function addAddress(address: {
//   addressTittle: string;
//   contactName: string;
//   contactNo: string;
//   addressLine1: string;
//   addressLine2?: string;
//   region: string;
//   country: string;
//   postalCode: string;
//   city: number;
//   userId: number;
//   primary?: boolean;
// }) {
//   return async (dispatch: any, getState: () => any) => {
//     // const { dispatch } = store;
//     try {
//       const formattedData = {
//         addressTittle: address.contactName,
//         contactName: address.contactName,
//         contactNo: address.contactNo,
//         addressLine1: address.addressLine1,
//         addressLine2: address.addressLine2,
//         state: address.region,
//         country: address.country,
//         zipCode: address.postalCode,
//         cityId: address.city,
//         userId: address.userId,
//         primary: address.primary ? true : false,
//       };
//       const response = await axiosInstance.post("/address", formattedData);
//       if (response?.data?.success) {
//         toast.success(response?.data?.message);
//         await dispatch(fetchUser(address.userId));
//         return response.data;
//       } else {
//         toast.error(response?.data?.message);
//         dispatch(hasError(response?.data?.message));
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
// }
export function addAddress(address: {
  addressTittle: string;
  contactName: string;
  contactNo: string;
  addressLine1: string;
  addressLine2?: string;
  state: string;
  zipCode: string;
  city: number;
  userId: number;
  primary?: boolean;
  addressType?: string;
}) {
  return async (dispatch: any, getState: () => any) => {
    try {
      const formattedData = {
        addressTittle: address.contactName, // Uses the combined firstName and lastName
        contactName: address.contactName, // The backend expects the contactName as a combined string
        contactNo: address.contactNo,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        state: address.state,
        zipCode: address.zipCode,
        cityId: address.city,
        userId: address.userId,
        addressType: address?.addressType
      };
      const response = await axiosInstance.post("/address", formattedData);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        await dispatch(fetchUser(address.userId));
        return response.data;
      } else {
        toast.error(response?.data?.message);
        dispatch(hasError(response?.data?.message));
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateAddress(address: {
  addressTittle: string;
  contactName: string;
  contactNo: string;
  addressLine1: string;
  addressLine2?: string;
  state: string;
  zipCode: string;
  city: number;
  userId: number;
  primary?: boolean;
  addressType: string;
  addressId: number;
}) {
  return async (dispatch: any, getState: () => any) => {
    // const { dispatch } = store;
    try {
      const formattedData = {
        addressTittle: address.contactName,
        contactName: address.contactName,
        contactNo: address.contactNo,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        zipCode: address.zipCode,
        cityId: address.city,
        userId: address.userId,
        primary: address.primary ? true : false,
        addressType: address?.addressType
      };
      const response = await axiosInstance.put(
        `/address/${address.addressId}`,
        formattedData
      );
      if (response?.data?.Success) {
        toast.success(response?.data?.Message);
        await dispatch(fetchUser(address.userId));
        return response.data;
      } else {
        toast.error(response?.data?.Message);
        dispatch(hasError(response?.data?.Message));
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function updateUser(id: number, data: any) {
  // const { dispatch } = store;
  return async (dispatch: any, getState: () => any) => {
    try {
      const response = await axiosInstance.put(`/user/${id}`, data);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        await dispatch(fetchUser(id));
      } else {
        toast.error(response?.data?.message);
        dispatch(hasError(response?.data?.message));
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function setDefaultAddress(id: number) {
  return async (dispatch: any, getState: () => any) => {
    try {
      const response = await axiosInstance.put(`/address/${id}/primary`);

      if (response.data?.success) {
        toast.success(response.data.message);
        await dispatch(fetchUser(response.data.user_id));
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };
}
